export default {
  install(Vue, enable) {
    if (enable) {
      Vue.prototype.log_info = console.log
    } else {
      Vue.prototype.log_info = function () {}
    }
  }
}
